import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from "utils/api/Api";
import { Loading } from "app/components/Loading";
import { ErrorMessageBox, Pagination } from "bf-library";
import moment from "moment";

export const UserLoginHistory = ()=>{
    const [page, setPage] = useState(0);

    const { data:history, isFetching, isError, error } =useQuery({
        queryKey:['user/login/list', page],
        queryFn:()=>Api.get(`/api/user/history/login?page=${page}`),
        refetchOnMount:'always',
    });

    if(isError) return <ErrorMessageBox message={createFetchErrorMessage(error).message} />;

    return (
        <div className="login_history">    
            <div className="list">
            {
                history?.data?.list.map(item=>{
                    return (
                        <div className="login">
                            <div className="datetime">{moment(item.createdAt).format('LLL')}</div>
                            <div className="memo"> {item.memo}</div>
                            <div className="os">
                                    {item.os}
                                    {item.browser && <small> - {item.browser}</small>}
                            </div>
                        </div>
                    )
                })
            }
            </div>
            <Loading overlay={true} active={isFetching} />
            <Pagination page={history?.data?.page || 0} totalPage={history?.data?.totalPages || 1} gotoPage={setPage} />
        </div>
    );
}